// REDUX
import { createSlice } from "@reduxjs/toolkit";
import { getPromoCodes } from "api/promoCodeApi";

// MISC
import { IPromoCodesInitialState } from "models/interfaces";

const initialState: IPromoCodesInitialState = {
  promoCodes: {
  },
  usersList: [],
  isLoading: false,
  errorMessage: "",
};

export const promoCodesSlice = createSlice({
  name: "promoCodes",
  initialState,
  reducers: {
    setUsersListState: (state, action) => {
      console.log("action.payload", action.payload)
      state.usersList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPromoCodes.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getPromoCodes.fulfilled, (state, action) => {
      state.isLoading = false;
      state.promoCodes = action.payload.content;
    });
    builder.addCase(getPromoCodes.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
    });
  },
});

//eslint-disable-next-line
export const {
  setUsersListState
} = promoCodesSlice.actions;

export const promoCodes = (state) => state.promoCodes.promoCodes;
export const usersList = (state) => state.promoCodes.usersList;

export default promoCodesSlice.reducer;
